import React from 'react'
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection'
import classNames from 'classnames'
import './MentionComponent.scss'

interface MentionComponentProps {
  nodeKey: string
  id: string
  mention: string
}
export const MentionComponent: React.FC<MentionComponentProps> = ({ nodeKey, mention }) => {
  const [isSelected, setSelected, clearSelection] = useLexicalNodeSelection(nodeKey)

  const handleOnClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    e.preventDefault()

    if (!isSelected) {
      clearSelection()
      setSelected(true)
    } else {
      setSelected(false)
    }
  }

  return (
    <span className={classNames('mention-node', { 'mention-node--selected': isSelected })} onClick={handleOnClick}>
      {mention}
    </span>
  )
}
